var _excluded = ["items", "limit", "onMoreClick", "seeMoreAfterItem", "seeMoreBeforeItem"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'semantic-ui-react';

/**
 * A possibly sliced list groups related content.
 *
 * @param {*} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
var SlicedList = function SlicedList(props) {
  var items = props.items,
    limit = props.limit,
    onMoreClick = props.onMoreClick,
    seeMoreAfterItem = props.seeMoreAfterItem,
    seeMoreBeforeItem = props.seeMoreBeforeItem,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var slicedItems = [];
  var _ref = _.isPlainObject(limit) ? limit : {
      from: 0,
      to: limit
    },
    from = _ref.from,
    to = _ref.to;
  slicedItems = _.slice(items, from, to);

  // S'il y a d'autres items avant ou après
  if (_.size(slicedItems) < _.size(items)) {
    if (seeMoreAfterItem !== false && to < items.length) {
      var afterSeeMore = seeMoreAfterItem || Object.assign({
        key: 'seeMoreAfterItem',
        content: '...',
        title: 'Voir plus'
      }, onMoreClick ? {
        onClick: function onClick(e) {
          return onMoreClick(e, 'after');
        }
      } : null);
      slicedItems = [].concat(slicedItems, [afterSeeMore]);
    }
    if (seeMoreBeforeItem !== false && from > 0) {
      var beforeSeeMore = seeMoreBeforeItem || Object.assign({
        key: 'seeMoreBeforeItem',
        content: '...',
        title: 'Voir plus'
      }, onMoreClick ? {
        onClick: function onClick(e) {
          return onMoreClick(e, 'before');
        }
      } : null);
      slicedItems = [beforeSeeMore].concat(slicedItems);
    }
  }
  return /*#__PURE__*/_jsx(List, Object.assign({
    items: slicedItems
  }, rest));
};
SlicedList.handledProps = ["items", "limit", "onMoreClick", "seeMoreAfterItem", "seeMoreBeforeItem"];
SlicedList.propTypes = {
  /** Shorthand array of props for ListItem. */
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.array,
  /** A list can limit its displayed items. Not including the given number. */
  limit: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    from: PropTypes.number,
    to: PropTypes.number
  })]),
  /**
   * onClick handler for "..." if there is a fixed limit.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param string target - Whether the event is fired from 'before' or 'after' see more item.
   */
  onMoreClick: PropTypes.func,
  /** A limited list may display a custom "see more" item at the end. It may hide it. */
  seeMoreAfterItem: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.node]),
  /** A limited list may display a custom "see more" item at the begining. It may hide it. */
  seeMoreBeforeItem: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.node])
};
SlicedList.defaultProps = {
  limit: 3
};
export default SlicedList;